import { conditionHolds } from "./when";
// Widget selector values as `sequent_core::monitoring::resolve` settles them:
// the viewer's pick, then the dashboard's value for the widget, then the
// selector's default. A value that is not an option — a pick kept in the
// session from an earlier revision — falls through instead of being sent.
export var ESelectorState;
(function (ESelectorState) {
    ESelectorState["VALUE"] = "VALUE";
    /** Its `when` condition does not hold: not shown, feeds nothing. */
    ESelectorState["HIDDEN"] = "HIDDEN";
    /** Its options come from the data, and there are none yet. */
    ESelectorState["NO_OPTIONS"] = "NO_OPTIONS";
})(ESelectorState || (ESelectorState = {}));
export var value = function (text) { return ({ kind: ESelectorState.VALUE, value: text }); };
export var hidden = function () { return ({ kind: ESelectorState.HIDDEN }); };
var noOptions = function () { return ({ kind: ESelectorState.NO_OPTIONS }); };
export function selectorOptions(selector, dynamic) {
    var _a, _b;
    if (selector.options_from) {
        return ((_a = dynamic[selector.options_from]) !== null && _a !== void 0 ? _a : []).map(function (option) { return ({
            value: option,
            label: option,
        }); });
    }
    return Object.entries((_b = selector.options) !== null && _b !== void 0 ? _b : {}).map(function (_a) {
        var option = _a[0], label = _a[1];
        return ({
            value: option,
            label: label,
        });
    });
}
export function resolveSelectors(widget, dashboardValues, requested, dynamic) {
    var _a;
    var states = {};
    return Object.entries((_a = widget.selectors) !== null && _a !== void 0 ? _a : {}).map(function (_a) {
        var name = _a[0], selector = _a[1];
        var options = selectorOptions(selector, dynamic);
        var state = selectorState(selector, options, states, requested[name], dashboardValues[name]);
        states[name] = state;
        return { name: name, selector: selector, options: options, state: state };
    });
}
function selectorState(selector, options, earlier, requested, dashboard) {
    var _a, _b;
    if (!conditionHolds(selector.when, earlier))
        return hidden();
    var offered = function (candidate) {
        return candidate !== undefined && options.some(function (option) { return option.value === candidate; });
    };
    if (offered(requested))
        return value(requested);
    if (offered(dashboard))
        return value(dashboard);
    var fallback = selector.options_from
        ? (_a = options.at(-1)) === null || _a === void 0 ? void 0 : _a.value
        : offered(selector.default)
            ? selector.default
            : (_b = options[0]) === null || _b === void 0 ? void 0 : _b.value;
    return fallback === undefined ? noOptions() : value(fallback);
}
/** The values a render or export request carries: the shown selectors that have one. */
export function selectorValuesForRequest(resolved) {
    return Object.fromEntries(resolved.flatMap(function (_a) {
        var name = _a.name, state = _a.state;
        return state.kind === ESelectorState.VALUE ? [[name, state.value]] : [];
    }));
}
/**
 * A dashboard export's `widget_selector_values`: each widget's values as the
 * dashboard draws it, by widget id. A widget placed twice is exported as its
 * first placement shows it.
 */
export function dashboardSelectorValues(cells, picksOf, dynamic) {
    var values = {};
    for (var _i = 0, cells_1 = cells; _i < cells_1.length; _i++) {
        var cell = cells_1[_i];
        if (!cell.widget || cell.widgetId in values)
            continue;
        values[cell.widgetId] = selectorValuesForRequest(resolveSelectors(cell.widget, cell.values, picksOf(cell), dynamic));
    }
    return values;
}
